// extracted by mini-css-extract-plugin
export default {"outer":"SidebarContent_outer__A9YGn"};